import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../components/Header.css';

function AdminNav({ onLogout }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLogoHovered, setIsLogoHovered] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const isActive = (path) => location.pathname === path;

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 80);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Dashboard', path: '/admin' },
    { label: 'Users',     path: '/admin/users' },
    { label: 'Products',  path: '/admin/products' },
    { label: 'Orders',    path: '/admin/orders' },
    { label: 'Reviews',   path: '/admin/reviews' },
    { label: 'Reports',   path: '/admin/reports' },
  ];

  return (
    <>
      {/* Main Navbar */}
      <header id="header" className={`header tra-menu navbar-light ${isScrolled ? 'header-hidden' : ''}`}>
        <div className="header-wrapper" style={{ maxWidth: '1400px', margin: '0 auto', padding: '0 40px' }}>
          <div className="wsmainfull menu clearfix">
            <div className="wsmainwp clearfix">
              <div className="desktoplogo" style={{ marginTop: '10px', position: 'relative' }}
                onMouseEnter={() => setIsLogoHovered(true)}
                onMouseLeave={() => setIsLogoHovered(false)}>
                <a onClick={() => navigate('/admin')} style={{ cursor: 'pointer', position: 'relative', display: 'inline-block' }}>
                  <img src="/images/corgif-logo.png" alt="header-logo" style={{ height: '140px', width: 'auto', transform: isLogoHovered ? 'perspective(500px) rotateY(-8deg)' : 'none', transformOrigin: 'left center', transition: 'transform 0.3s' }} />
                </a>
              </div>

              <nav className="wsmenu clearfix">
                <ul className="wsmenu-list" style={{ display: 'flex', gap: '30px', minWidth: '700px', justifyContent: 'flex-start' }}>
                  {navLinks.map(({ label, path }) => (
                    <li key={path} className="nl-simple" aria-haspopup="true">
                      <a onClick={() => navigate(path)} className="nav-link"
                        style={{ cursor: 'pointer', fontWeight: isActive(path) ? '700' : '500', color: '#333' }}>
                        {label}
                      </a>
                    </li>
                  ))}
                  <li className="nl-simple" aria-haspopup="true">
                    <a onClick={onLogout} className="btn logout-btn"
                      style={{ cursor: 'pointer', borderRadius: '25px', padding: '6px 20px', minWidth: '120px', textAlign: 'center', color: 'white', backgroundColor: '#ff0000' }}>
                      Logout
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </header>

      {/* Compact Navbar */}
      <div className={`compact-header ${isScrolled ? 'compact-header-visible' : ''}`}>
        <div className="compact-header-container">
          <div className="compact-logo">
            <a onClick={() => navigate('/admin')} style={{ cursor: 'pointer' }}>
              <img src="/images/corgif-logo.png" alt="corgif Logo" />
            </a>
          </div>

          <nav className="compact-nav">
            {navLinks.map(({ label, path }) => (
              <a key={path} onClick={() => navigate(path)} className="compact-nav-link"
                style={{ cursor: 'pointer', fontWeight: isActive(path) ? '700' : '500', color: '#333' }}>
                {label}
              </a>
            ))}
          </nav>

          <div className="compact-actions">
            <a onClick={onLogout} className="compact-login-btn"
              style={{ cursor: 'pointer', backgroundColor: '#ff0000' }}>
              Logout
            </a>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdminNav;
